// extracted by mini-css-extract-plugin
export default {"item":"style_item__7g2xO","title":"style_title__rHQpk","date":"style_date__jQRco","amount":"style_amount__yKb23","check":"style_check__BvMB9","bonuses":"style_bonuses__3KoiL"};